export default "__VITE_ASSET__DaOHLiP___"